import ProfileLink from './link/component-lib.esm.js';
import ProfileFeed from './feed/component-lib.esm.js';
import ProfileEmbed from './embed/component-lib.esm.js';
import ProfileDivider from './divider/component-lib.esm.js';
import ProfileCarousel from './carousel/component-lib.esm.js';
import ProfileTitle from './title/component-lib.esm.js';
import ProfileForm from './form/component-lib.esm.js';
import ProfileOptInForm from './opt-in-form/component-lib.esm.js';
import ProfileRequest from './commerce/component-lib.esm2.js';
import ProfileSupport from './commerce/component-lib.esm.js';
import ProfileImageGrid from './image-grid/component-lib.esm.js';
import ProfileText from './text/component-lib.esm.js';
import ProfileContactDetails from './contact-details/component-lib.esm.js';
import ProfileShop from './shop/component-lib.esm.js';
const PREVIEW_COMPONENT_MAPPING = {
  'opt-in-form': ProfileOptInForm,
  'contact-details': ProfileContactDetails,
  title: ProfileTitle,
  delimiter: ProfileDivider,
  divider: ProfileDivider,
  carousel: ProfileCarousel,
  feed: ProfileFeed,
  embed: ProfileEmbed,
  form: ProfileForm,
  request: ProfileRequest,
  support: ProfileSupport,
  'image-grid': ProfileImageGrid,
  text: ProfileText,
  group: 'ProfileGroup',
  shop: ProfileShop
};
const PROFILE_LINK_COMPONENTS = {
  ProfileLink,
  ProfileFeed,
  ProfileEmbed,
  ProfileDivider,
  ProfileCarousel,
  ProfileTitle,
  ProfileForm,
  ProfileOptInForm,
  ProfileRequest,
  ProfileSupport,
  ProfileImageGrid,
  ProfileText,
  ProfileContactDetails,
  ProfileShop
};
function getLinkType(link) {
  const type = PREVIEW_COMPONENT_MAPPING[link.type];
  return type ? type : ProfileLink;
}
export { PREVIEW_COMPONENT_MAPPING, PROFILE_LINK_COMPONENTS, getLinkType };